import React from 'react';
import PropTypes from 'prop-types';
import s from './SidebarHTMLContent.module.css';

const SidebarHTMLContent = ({ html, centerContent }) => (
  <div
    style={{ textAlign: centerContent ? 'center' : 'left' }}
    className={s.content}
    dangerouslySetInnerHTML={{ __html: html }}
  />
);

SidebarHTMLContent.defaultProps = {
  html: '',
  centerContent: true,
};

SidebarHTMLContent.propTypes = {
  html: PropTypes.string,
  centerContent: PropTypes.bool,
};

export default SidebarHTMLContent;
